import React from "react";
import { cn } from "./cn";

/** Keyboard hint chip: menu shortcuts, command-palette hints. */
export default function Kbd({ subtle, className, children }) {
  return (
    <kbd
      className={cn(
        "inline-flex items-center justify-center font-instrument not-italic",
        "text-[11px] font-strong border border-bun-line rounded-[5px] px-[6px] py-px",
        subtle ? "text-bun-faint bg-transparent" : "text-bun-text bg-bun-mist",
        className
      )}
    >
      {children}
    </kbd>
  );
}
